module.exports = __webpack_public_path__ + "static/media/5-star-clubhouse.d3d05699.svg";